import React, { useEffect } from 'react';
import ToolCardInt from './ToolCardInt';
import './ToolsInt.css';
import BottomCardGroupInt from "../../BottomCardGroupInt/BottomCardGroupInt";

function ToolsInt(props) {
	const { data, bottomCard, campaignOrg, swipeActions } = props;
	useEffect(() => {
	}, []);
	return (
	<>
		<div className="page-content page-content-tool" {...swipeActions}>
			<div className="tool-page-header">
				<h2>Tools to Get Ahead</h2>
				<p>Use these tools to improve your store performance and earn upto 3x every month! </p>
			</div>
			
			<div className="tools-page-card-box">
				<ToolCardInt data={data} isTab />
			</div>
			<div style={{visibility: 'hidden'}}>
			<BottomCardGroupInt bottomCard={bottomCard} campaignOrg={campaignOrg}></BottomCardGroupInt>
			</div>
		</div>
	</>
	);
}

export default ToolsInt;
